import React, { useEffect, useState } from "react";
import { useFetch } from "../Components/Base/Hooks/basicFetch";

const SessionInfo = ({ currentState, updateState }) => {
  const [authKey, setAuthKey] = useState();
  const [refreshFlag, setRefreshFlag] = useState(false);
  const { data: sessionInfoData } = useFetch(
    "/v1/client/session/",
    {
      method: "GET",
      values: null,
      key: authKey,
    },
    refreshFlag,
  );

  useEffect(() => {
    if (currentState.authKey && currentState.authKey !== authKey) {
      setAuthKey(currentState.authKey);
      setRefreshFlag(true);
    }
  }, [currentState.authKey]);

  useEffect(() => {
    if (sessionInfoData?.data) {
      updateState("sessionInfo", { ...sessionInfoData.data });
    }
  }, [sessionInfoData]);

  return null;
};

export default SessionInfo;
